module.exports = __webpack_public_path__ + "assets/img/mecha6-7a6a5030.jpg";